<div class="row dash" [@routerTransition]>
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form background-card-primary3">
    <div class="card-body padding-all-0px margin-left-zero">
      <div>
        <div class="">
          <div class="row" *ngIf="ShowSkillsList">
            <!--<div><span class="s-title"><span class="xs-hide">Skills</span> <span class="s-icon"><i class="fas fa-caret-up"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></div>-->
            <div class="col-md-8 padding-right">
              <div *ngIf='IsShowActorFormList'>
                <div class="card skillassest">
                  <div class="card-header wh-header">
                    My Skills
                    <!--<button type="button" (click)="openNewContent()" class="btn actions-btn-prime"
                            style="float:right;">
                      <i class="fas fa-plus"></i>
                    </button>-->
                  </div>
                  <div class="card-body search-body">
                    <div class="row">
                      <div class="card col-md-5 card-border margin-right-8 " *ngFor="let l of CurrentFdActorReportsDocController">
                        <div class="card-header  card-header2 padding-bottom">
                          <div class="row">
                            <div class="col-md-9">
                              <div class="badge contracts-badge4">{{l.TemplateName}}</div>  
                            </div>
                            <div class="col-md-1 padding-lr-0px col-md-margin">
                              <a class="" (click)="Edit_(l.ActorReportCode)" title="Edit"><i class="fas fa-pencil-alt  nav-link-hand float-right "></i></a>

                            </div>
                            <div class="col-md-1 padding-lr-0px col-md-margin">

                              <a (click)="del_(l.ActorReportCode)" title="Remove"><i class="far fa-trash-alt  nav-link-hand float-right navlink-hand2"></i></a>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-9 float-left attribute4">
                              <label class="label-specialty-11">{{l.Specialty}}</label>
                            </div>
                          </div>

                          <!--<a (click)="del_(l.ActorReportCode)" class="margin-top-3px margin-right-3px"><i class="far fa-trash-alt  nav-link-hand float-right navlink-hand2"></i></a>
                          <a (click)="Edit_(l.ActorReportCode)" class="margin-top-3px margin-left-3px"><i class="fas fa-pencil-alt  nav-link-hand float-right"></i></a>-->
                        </div>
                        <div class="card-body bar-char2 ">
                          <div class="row">
                            <label class="score-label">
                              {{l.ScorePercent}}<span class="span-color">%</span>
                            </label>
                            <!--<ngx-charts-gauge [view]="view"
                                              [scheme]="colorScheme"
                                              [results]="GetChartData(l)"
                                              [min]="0"
                                              [max]="100"
                                              [angleSpan]="240"
                                              [startAngle]="-120"

                                              [bigSegments]="2"
                                              [smallSegments]="2"
                                              [legend]="false"
                                            >
                            </ngx-charts-gauge>-->
                          </div>

                          <div class="row margin-left-zero margin-right row-background">
                            <label class="margin-bottom-0px label-last "> Last Modified: {{l.Date | date:'dd-MMM-yyyy'}}</label>
                            <!--<a  class="nav-link-hand "><i class="fas fa-pencil-alt float-right"></i></a>-->
                          </div>




                        </div>

                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-md-4 padding-left-zero row-background ">
              <div class="card actor-card">
                <div class="card-header wh-header background-2 row-background ">Catalogue</div>
                <div class="card-body padding-all-0px margin-left-zero row-background ">
                  <div class="padding-left-21">
                    <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                  </div>
                  <!--<div class="row margin-left-zero margin-right border4 margin-top-3px margin-left-17" *ngFor="let l of CurrentCustomCodeValuesController">
                    <div class="col-md-1  margin-tb-auto padding-lr-2px">
                      <button type="button" class="btn  btn-sm driver-button " id="FileUpload"
                              name="upload">
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                    <div class="col-md-11 margin-tb-auto padding-l-0px padding-left-4">
                      <label class="margin-bottom-0px color3">{{l.DisplayName}}</label>
                    </div>
                  </div>-->
                  <div class="table-component actor-table">

                    <div class="table-responsive padding-right-11px">


                      <table class="table table-striped margin-left-24px">
                        <tbody>
                          <tr *ngFor="let l of pdata">
                            <td class="td-padding2 ">

                              <div class="row margin-left-zero margin-right border4 margin-top-3px">
                                <div class="col-md-1  margin-tb-auto padding-lr-2px">
                                  <button type="button"
                                          (click)="ConfirmAndProceedToAddSkill(l)"
                                          class="btn  btn-sm driver-button " id="FileUpload"
                                          name="upload">
                                    <i class="fas fa-plus font-size-11"></i>
                                  </button>
                                </div>
                                <div class="col-md-11 margin-tb-auto padding-left-11px">
                                  <label class="margin-bottom-0px color3">{{l.DisplayName}}</label>
                                  <label class="">{{l.Specialty}}</label>
                                </div>
                              </div>


                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="row" *ngIf="ShowQuestionnaire">
            <!--<div><span class="s-title"><span class="xs-hide">Skills</span> <span class="s-icon"><i class="fas fa-caret-up"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></div>-->
            <div class="col-md-12">

              <div class="card skillassest">
                <div class="card-header wh-header">
                  Skill Update: {{TemplateName}}
                  <div class="row float-right margin-right-0px margin-left-zero">
                    <div class="col-md-4 padding-right padding-l-0px margin-right-16px">
                      <button (click)="CancelUpdateOperation()" *ngIf='!isRequesting' class="btn button-Schedule actions-btn-prime nav-link-hand actions-btn-prime3 margin-right-12px">Cancel</button>

                    </div>
                    <div class="col-md-4 padding-l-0px padding-right-0px">
                      <div *ngIf="CurrentFdActorDocReportDetailsController">
                        <div *ngIf="CurrentFdActorDocReportDetailsController.length >0 && ActorReportCode >0  && IsRateing">
                          <button type="submit" class="btn actions-btn-prime margin-left-zero" (click)="SaveFDActorDocReportDetails()" *ngIf='!isRequesting'>Save</button>
                          </div>
                        </div>
                        </div>
                    <div class="col-md-2 padding-l-0px padding-right-0px">

                      <div *ngIf="CurrentFdActorDocReportDetailsController">
                        <div *ngIf="CurrentFdActorDocReportDetailsController.length >0 && ActorReportCode >0  && IsRateing">
                          <ul class="nav navbar-nav">
                            <li class="dropdown">
                              <a href="#" class="dropdown-toggle" data-toggle="dropdown"><i class="fas fa-info-circle"></i> <!--<span class="glyphicon glyphicon-user pull-right"></span>--></a>
                              <ul class="dropdown-menu">
                                <li><a ><span>0</span> Not Applicable </a></li>
                                <li><a><span>1</span> No Experience </a></li>
                                <li><a><span>2</span> Some Expericence (Require Assistance) </a></li>
                                <li><a><span>3</span> Intermittent Experience (May Require Assistance) </a></li>
                                <li><a><span>4</span> Experienced (Performs without Assistance) </a></li>
                                <li><a><span>5</span> Very Experienced (Able to Teach/Supervise) </a></li>
                              </ul>
                            </li>
                          </ul>
                        </div>
                      </div>
                    
                    </div>
                      </div>
                      <div class=" float-right">

                      </div>

                      <!--<button type="button" (click)="openNewContent()" class="btn actions-btn-prime"
          style="float:right;">
    <i class="fas fa-plus"></i>
  </button>-->

                    </div>
                <div class="card-body search-body  padding-left-0px padding-right-0px">
                  <!--<div class="row search-box">
                    <div class="col-md-2"><span class="pink-round-broder"><img src="../../../../../../../../wwwroot/healins-assets/images/admin/skillsassessment.png"></span></div>
                    <div class="col-md-8">

                      <div class="row">

                        <div class="form-group col-md-6 col-xs-12">
                          <label for="fitnessType">Select Form</label>

                          <select class="form-control" id="ActorReportCode"
                                  name="ActorReportCode" [(ngModel)]="ActorReportCode"
                                  (change)="onChangeTemplate($event.target.value)"
                                  required>

                            <option selected="" value="0"></option>
                            <option *ngFor="let R of CurrentFdActorReportsDocController" [value]="R.ActorReportCode">
                              {{R.TemplateName}}
                            </option>


                          </select>
                        </div>

                      </div>
                    </div>
                    <div class="col-md-2"></div>
                  </div>-->

                  <div class="card-content" *ngIf="ActorReportCode >0 && IsRateing">
                    <div class="row">
                      <div class="offset-md-3 col-md-6 col-sm-12">
                        <div class="table-responsive">
                          <div class="rTable">
                            <div *ngIf="SelectedQA">
                              <div *ngFor="let group of SelectedQA; let gin = index">
                                <!--{{group.Title}}-->

                                <div *ngIf="group.Questions.length >0" class="heading-pinkbg padding-all-0px font-size-14px font-weight-bold">{{group.Title}}</div>
                                <!--<div *ngIf="group.Questions">-->
                                <!--<div class="heading-pinkbg">{{group.SectionTitle}}</div>-->
                                <!--<div class="table-responsive product-chart-wrapper ps" data-ps-id="23424243">
          <div class="rTable">-->
                                <div class="rTableRow qa-grid-wrapper dispaly3" *ngFor="let c of group.Questions; let i = index" [ngSwitch]="c.ValueType">
                                  <div class="_rTableCell font-size-14px margin-tb-auto">{{c.AttributeName}}</div>
                                  <div class="_rTableCell-right " *ngSwitchCase="'CsvList'">
                                    <div class="form-check form-check-inline" *ngFor="let cc of c.ValueSource | splitpipe:','">
                                      <label class="form-check-label font-size-14px">
                                        <input class="form-check-input radio-input-right" type="radio" value="{{cc}}" name="{{gin}}{{i}}"
                                               [(ngModel)]="c.ValueData"
                                               placeholder="Value" checked="checked">  {{cc}}
                                        <i class="input-helper"></i>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                           
                          </div>
                         
                        
                        </div>
                      </div>
                    </div>
                  
                  
                  </div>
                </div>

                <div *ngIf="CurrentFdActorDocReportDetailsController">
                  <div class="card-content" *ngIf="CurrentFdActorDocReportDetailsController.length >0 && ActorReportCode >0  && !IsRateing">
                    <h1> Template is Not Supporting</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
